import { BlockScormContent } from 'store/states/lessons.state'
import api from '../..'

export const getScormBlock = (blockId: number) => {
  return api.get(`block_scorm/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): BlockScormContent => {
      const {
        id,
        showTitle,
        url,
        fileData,
        blockInstanceableId,
        blockInstanceable,
        isValidated,
        processed,
        loadPercentage,
        processing,
        openNewWindow,
        blockAdvance,
      } = attributes
      const { name, mandatory, order, description, blockInstanceableType } =
        blockInstanceable
      return {
        id,
        blockInstanceableId,
        blockInstanceable,
        name,
        mandatory,
        order,
        description,
        type: blockInstanceableType,
        fileData,
        url,
        showTitle,
        isValidated,
        processed,
        loadPercentage,
        processing,
        openNewWindow,
        blockAdvance,
      }
    }
  )
}
